$(function() {
	return $(document).on('ready page:load', function() {
		return $(document).on('click', '#get-adquirer', function() {

			identification_type = $('#client_identification_type').val()
			identification_number = $('#client_identification_number').val()

			if (identification_number === ''){
        showAlert("Para obtener la información desde la DIAN es necesario ingresar el tipo de identificación y el número de identificación.", 4000);
				return
			}

			let url = `/get_adquirer/${identification_type}/${identification_number}.json`;
			fetch(url)
			.then(res => res.json())
			.then(data => {
				if (data["status"] === 404) {
          showAlert(data["msg"] + ' de la DIAN', 4000);
					return
				} else {
					$('#client_email').val(data["receiver_email"])
					$('#client_name').val(data["receiver_name"])
          showAlert("Se han obtenido los datos de la DIAN correctamente.", 4000);
				}
			})
			.catch(err => console.log(err));
		});
	});
});


function showAlert(message, duration = 3000) {
  // Crear el estilo si aún no existe
  if (!document.getElementById('custom-alert-style')) {
    const style = document.createElement('style');
    style.id = 'custom-alert-style';
    style.textContent = `
      .custom-alert {
        position: fixed;
        top: 20px;
        right: 20px;
        background-color: #323232;
        color: white;
        padding: 15px 25px;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        z-index: 9999;
        opacity: 0;
        transform: translateY(-20px);
        transition: opacity 0.4s, transform 0.4s;
        font-family: sans-serif;
        max-width: 300px;
      }
      .custom-alert.show {
        opacity: 1;
        transform: translateY(0);
      }
    `;
    document.head.appendChild(style);
  }

  // Crear la alerta
  const alert = document.createElement('div');
  alert.className = 'custom-alert';
  alert.textContent = message;
  document.body.appendChild(alert);

  // Mostrarla
  requestAnimationFrame(() => alert.classList.add('show'));

  // Ocultarla y eliminarla
  setTimeout(() => {
    alert.classList.remove('show');
    setTimeout(() => alert.remove(), 400);
  }, duration);
}
